import styled, { css } from 'styled-components';

import { InputField } from 'components/fields';
import { captionRegular, messagesRegular } from 'styles/mixins/fonts';
import { AddButton, DeleteButton } from 'components/specified-buttons';

export const Container = styled.div`
  flex: 1;
  display: flex;
  overflow-y: auto;
  overflow-x: hidden;
  flex-direction: column;
`;

export const Title = styled.p`
  ${messagesRegular};
`;

export const SwitchSubtitle = styled.p`
  ${captionRegular};
  color: ${({ theme }) => theme.colors.grey.primary.standard};
`;

export const StyledInput = styled(InputField)`
  width: 136px;
`;

export const StyledDeleteButton = styled(DeleteButton)`
  flex-shrink: 0;
  margin-top: 24px;
`;

export const StyledAddButton = styled(AddButton)`
  margin-top: 0;
`;

/**
 * Payroll settings: "input | toggle" on one row. On desktop the input keeps
 * the page's input width (the column) and the toggle sits just past it; on
 * tablet/phone, where inputs span the row, the input gives the toggle 64px.
 */
export const InlineSetting = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;

  ${({ theme }) =>
    theme.responsive.isDesktop &&
    css`
      margin-right: -64px;
    `}
`;

export const InlineInput = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

// Same height as the input and pushed down by its 24px label, so the
// toggle's centre line is the input's centre line (measured).
export const InlineToggle = styled.div`
  display: flex;
  flex: 0 0 48px;
  height: 40px;
  margin-top: 24px;
  align-items: center;
`;
